import { render, staticRenderFns } from "./AdDetailView.vue?vue&type=template&id=6b860c0d&scoped=true&"
import script from "./AdDetailView.vue?vue&type=script&lang=js&"
export * from "./AdDetailView.vue?vue&type=script&lang=js&"
import style0 from "./AdDetailView.vue?vue&type=style&index=0&id=6b860c0d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b860c0d",
  null
  
)

export default component.exports